/**
 * A framework-agnostic navigation service that decouples modules that need to
 * trigger navigation (e.g. the Axios client) from the React Router instance.
 *
 * Usage:
 *   - Call `navigationService.setNavigate(fn)` once, right after the router is
 *     created (in app.tsx).
 *   - Call `navigationService.navigate(path)` from anywhere (e.g. client.ts).
 *
 * This file intentionally has no application imports so it sits at the bottom
 * of the dependency graph and never causes import cycles.
 */

type NavigateFn = (to: string) => void;

// eslint-disable-next-line no-underscore-dangle
let _navigate: NavigateFn | null = null;

export const navigationService = {
  setNavigate(fn: NavigateFn) {
    _navigate = fn;
  },
  navigate(to: string) {
    if (_navigate) {
      _navigate(to);
    }
  },
};
